import React from 'react';
import ReactDOM from 'react-dom';
import { CravingApp } from './CravingApp';

import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'

import global_es from './translations/es/global.json';
import global_en from './translations/en/global.json';

import './index.css';

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources:{
    es:{
      global: global_es,
    },
    en:{
      global: global_en,
    },
  },
});

ReactDOM.render(
  <I18nextProvider i18n={ i18next }>
    <CravingApp />
  </I18nextProvider>,
  document.getElementById('root')
);

